import { GET_ALERTS_BY_LATLON, GET_NOTIFICATIONS, GET_NOTIFICATIONS_STATUS } from '../actions/alertsActions';

import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    alerts: {},
    alertsIsRefreshing: false,
    notifications: {},
    notificationsIsRefreshing: false,
    notificationsStatus: [],
    notificationsStatusIsRefreshing: false,
    lastError: undefined

};

export function alerts(state = initialState, action) {
    switch (action.type) {
        case LOCATION_CHANGED:
        {
            return initialState;
        }

        case GET_ALERTS_BY_LATLON.pending:
        {
            return {
                ...state,
                alertsIsRefreshing: true
            };
        }

        case GET_ALERTS_BY_LATLON.fulfilled:
        {
            return {
                ...state,
                alerts: action.payload,
                lastError: {},
                alertsIsRefreshing: false
            };
        }

        case GET_ALERTS_BY_LATLON.rejected:
        {
            return {
                ...state,
                alerts: undefined,
                lastError: action.payload,
                alertsIsRefreshing: false
            };
        }
        case GET_NOTIFICATIONS.pending:
        {
            return {
                ...state,
                notificationsIsRefreshing: true
            };
        }

        case GET_NOTIFICATIONS.fulfilled:
        {
            return {
                ...state,
                notifications: action.payload,
                lastError: {},
                notificationsIsRefreshing: false
            };
        }

        case GET_NOTIFICATIONS.rejected:
        {
            return {
                ...state,
                notifications: undefined,
                lastError: action.payload,
                notificationsIsRefreshing: false
            };
        }

        case GET_NOTIFICATIONS_STATUS.pending:
        {
            return {
                ...state,
                notificationsStatusIsRefreshing: true
            };
        }

        case GET_NOTIFICATIONS_STATUS.fulfilled:
        {
            const notificationsStatus = [ ...state.notificationsStatus?.filter(n => n.eml !== action.payload.eml), action.payload ];

            return {
                ...state,
                notificationsStatus,
                lastError: {},
                notificationsStatusIsRefreshing: false
            };
        }

        case GET_NOTIFICATIONS_STATUS.rejected:
        {
            return {
                ...state,
                notificationsStatus: undefined,
                lastError: action.payload,
                notificationsStatusIsRefreshing: false
            };
        }

        default:
        {
            return state;
        }
    }
}
